import { render } from "./SkillCard.vue?vue&type=template&id=49d0629c"
import script from "./SkillCard.vue?vue&type=script&lang=js"
export * from "./SkillCard.vue?vue&type=script&lang=js"

import "./SkillCard.vue?vue&type=style&index=0&id=49d0629c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__